// Librearias
import React, {Component, PropTypes} from 'react'
// Modules
import { Estado } from './Estado.jsx'

export class PanelEstados extends Component {
    render(){
        const { idEstado, tiene_gps } = this.props;
        let acciones = [];
        if (tiene_gps) {
            // acciones normales
            acciones = [
                {
                    texto: this.props.nominaCompleta
                        ? 'Informar nómina por correo'
                        : 'Revise Operadores y/o Total asignado',
                    onclick: this.props.informarNomina,
                    habilitado:
                        idEstado == 4 &&
                        this.props.permisos.informar &&
                        this.props.nominaCompleta &&
                        !this.props.operadoresPendientes
                },
                {
                    texto: 'Rechazar nómina',
                    onclick: this.props.rechazarNomina,
                    habilitado: idEstado == 4 && this.props.permisos.aprobar
                },
                {
                    texto: 'Completar sin envio de correo',
                    onclick: this.props.completarSinCorreo,
                    habilitado:
                        idEstado == 4 &&
                        this.props.permisos.rectificar &&
                        !this.props.operadoresPendientes,
                    cambio_lider: this.props.cambio_lider
                }
            ];
        } else {
            // solo Agregar GPS y Rechazar nómina
            acciones = [
                {
                    texto: 'Agregar GPS',
                    onclick: this.props.abrirModalGPS, // tu función
                    habilitado: true
                },
                {
                    texto: 'Rechazar nómina',
                    onclick: this.props.rechazarNomina,
                    habilitado: idEstado == 4 && this.props.permisos.aprobar
                }
            ];
        }
        return  <div className="row">
            {/* Pendiente */}
            <Estado
                titulo="Pendiente"
                descripcion="La nómina se encuentra pendiente"
                activo={idEstado==2}
                acciones={[
                    {
                        texto: 'Enviar nómina',onclick: this.props.enviarNomina,
                        habilitado: idEstado==2 && this.props.permisos.enviar
                    }
                ]}
            />
            {/* Recibida */}
            <Estado
                titulo="Recibida"
                descripcion="Dotación recibida por SEI"
                activo={idEstado==3}
                acciones={[
                    {
                        texto: 'Aprobar nómina', onclick: this.props.aprobarNomina,
                        habilitado: idEstado==3 && this.props.permisos.aprobar,
                        tooltip: true
                    },{
                        texto: 'Rechazar nómina', onclick: this.props.rechazarNomina,
                        habilitado: idEstado==3 && this.props.permisos.aprobar 
                    }
                ]}
            />
            {/* Aprobada */}
            <Estado
                titulo="Aprobada"
                descripcion="Dotación aprobada por SEI"
                activo={idEstado==4}
                acciones={acciones}
            />
            {/* Informada */}
            <Estado
                titulo={this.props.haSidoRectificada==1? "Informada (y rectificada)" : "Informada"}
                descripcion="El cliente ha sido informado por correo"
                activo={idEstado==5}
                acciones={[
                    {
                        texto: 'Rectificar Nómina', onclick: this.props.rectificarNomina,
                        habilitado: (idEstado==5 && this.props.permisos.rectificar && !this.props.operadoresPendientes && this.props.rectificaSistema === 1) || (idEstado==5 && this.props.permisos.rectificarTodas)
                    }
                ]}
            />
        </div>
    }
}

PanelEstados.propTypes = {
    idEstado: PropTypes.number.isRequired,
    haSidoRectificada: PropTypes.number.isRequired,
    // Se espera que estos metodos retornen una promesa:
    enviarNomina: PropTypes.func.isRequired,
    aprobarNomina: PropTypes.func.isRequired,
    rechazarNomina: PropTypes.func.isRequired,
    informarNomina: PropTypes.func.isRequired,
    completarSinCorreo: PropTypes.func.isRequired,
    rectificarNomina: PropTypes.func.isRequired,
    nominaCompleta: PropTypes.bool.isRequired,
    // Permisos
    permisos: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/components/PanelEstados.jsx